//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Dialog } from 'vant'
import { isValidDate } from '../const'
import money_input from '../_mixins/money_input'
export default {
    mixins: [
        money_input
    ],
    option: {
        virtualHost: true
    },
    props: {
        is_couple: Boolean,
        record: Object,
        max_date: String,
        min_date: String,
        len: Number,
        index: Number
    },
    data () {
        const date = new Date()
        return {
            show_start_date_picker: false,
            show_end_date_picker: false,
            current_date: `${date.getFullYear()}-${date.getMonth() + 1}`,
            default_min_date: '2000-01'
        }
    },
    computed: {
        is_first () {
            return this.index === 0
        },
        is_last () {
            return this.index === this.len - 1
        }
    },
    methods: {
        del () {
            Dialog.confirm({
                title: '提示',
                message: '确定要删除本段记录吗？'
            }).then(() => {
                this.$emit('del', this.index)
            })
        },
        confirm (type, e) {
            console.error('change', e)
            const value = e.getFullYear() + '-' + (e.getMonth() + 1)
            const record = {
                ...this.record,
                [type]: value
            }
            const { start, end } = record
            if (start && end && !isValidDate(start, end, true)) {
                wx.showToast({
                    title: '起始月份不能晚于截止月份',
                    icon: 'none'
                })
                return
            }
            this.show_start_date_picker = false
            this.show_end_date_picker = false
            this.$emit('change', record)
        }
    }
}
